/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contextual.onboarding.rpc.PlanOverviewChirpService
 */

export const getGuidesRpc = {
  serviceName: 'com.hubspot.contextual.onboarding.rpc.PlanOverviewChirpService',
  rpcName: 'getGuides',
  auth: 'app',
  fingerprint: 'Ib-XL2pLQ8I10yecWjFvurrBfmIZ0NcM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTasksForPortalUsersPagedRpc = {
  serviceName: 'com.hubspot.contextual.onboarding.rpc.PlanOverviewChirpService',
  rpcName: 'getTasksForPortalUsersPaged',
  auth: 'app',
  fingerprint: 'Hp4vA2VF4S3nF8gKEU_U2brBfmIZ0NcM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTaskGroupProgressWithDatesRpc = {
  serviceName: 'com.hubspot.contextual.onboarding.rpc.PlanOverviewChirpService',
  rpcName: 'getTaskGroupProgressWithDates',
  auth: 'app',
  fingerprint: 'xJXkz8PP_PCJW9VB9d3fA7rBfmIZ0NcM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGuideProgressWithDatesRpc = {
  serviceName: 'com.hubspot.contextual.onboarding.rpc.PlanOverviewChirpService',
  rpcName: 'getGuideProgressWithDates',
  auth: 'app',
  fingerprint: 'Z__pf4O4o4Q2O7KD3zdYV7rBfmIZ0NcM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};